import React from 'react'
import Support from './Support'
import Ticket from './Ticket'

function SupportPage() {
  return (
    <div>
      <Support/>
      <Ticket/>
    </div>
  )
}

export default SupportPage
